import {
  BoltOutlined,
  BookmarkBorderOutlined,
  BugReportOutlined,
  DescriptionOutlined,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { TaskTypeRef } from '@/tracker/types';

// Тип задачи — глобальный справочник; незнакомый тип рисуем как обычную задачу
const ICONS: Record<string, typeof DescriptionOutlined> = {
  bug: BugReportOutlined,
  story: BookmarkBorderOutlined,
  epic: BoltOutlined,
};

const IssueTypeIcon: React.FC<{ type: TaskTypeRef }> = ({ type }) => {
  const Icon = ICONS[type.key] ?? DescriptionOutlined;

  return (
    <Tooltip title={type.name}>
      <Icon
        aria-label={`Тип: ${type.name}`}
        sx={{ fontSize: 18, color: 'var(--dark-secondary-color)', verticalAlign: 'middle' }}
      />
    </Tooltip>
  );
};

export { IssueTypeIcon };
